<template>
  <div
    class="ColoredTag"
    :class="{
      'tag-blue': color === 'blue',
      'tag-dark-blue': color === 'dark-blue',
      'tag-opaque-blue': color === 'opaque-blue',
      'tag-green': color === 'green',
      'tag-green-alt': color === 'green-alt',
      'tag-orange': color === 'orange',
      'tag-pink': color === 'pink',
      'tag-purple': color === 'purple',
      'tag-purple-alt': color === 'purple-alt',
      'tag-red-alt': color === 'red-alt',
    }"
  >
    {{ text }}
  </div>
</template>

<script type="text/javascript">
  export default {
    props: {
      color: {
        type: String,
        default: '',
      },
      text: {
        type: String,
        default: '',
      },
    },
  }
</script>

<style lang="scss">
.ColoredTag {
  border: 1px solid $color-0_28_75_08;
  border-radius: 3px;
  display: inline-block;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.32px;
  line-height: 20px;
  text-transform: uppercase;
  padding: 2px 8px;
}
</style>
